import React, { useEffect, useState } from 'react';
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './Wysiwyg.scss';
const Wysiwyg = ({ formik }) => {
  const [moduleInfo, setModuleInfo] = useState({
    description: '',
  });
  const contentBlock =
    typeof window !== 'undefined'
      ? htmlToDraft(formik.values?.description)
      : null;

  let editorState = contentBlock
    ? EditorState.createWithContent(
      ContentState.createFromBlockArray(contentBlock.contentBlocks)
    )
    : EditorState.createEmpty();
  const [description, setDescription] = useState(editorState);
  const onEditorStateChange = (editorState) => {
    setDescription(editorState);
  };

  //every time when typing then store the valus in the formik
  useEffect(() => {
    formik.setFieldValue(
      'description',
      draftToHtml(convertToRaw(description.getCurrentContent()))
    );
  }, [description]);

  const toolbarOptions = {
    options: [
      'inline',
      'blockType',
      'fontSize',
      'fontFamily',
      'list',
      'textAlign',
      'colorPicker',
      'link',
      'remove'
      // 'embedded',
    ],
    inline: {
      options: ['bold', 'italic', 'underline', 'strikethrough'],
    },
    blockType: {
      options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote'],
    },
    fontSize: {
      options: [12, 14, 16, 18, 24, 30, 36, 48],
    },
    fontFamily: {
      options: [
        'Roboto',
        'Poppins',
        'Courier',
        'Courier-Bold',
        'Courier-Oblique',
        'Courier-BoldOblique',
        'Helvetica',
        'Helvetica-Bold',
        'Helvetica-Oblique',
        'Helvetica-BoldOblique',
        'Times-Roman',
        'Times-Italic',
      ],
    },
    list: {
      options: ['unordered', 'ordered'],
    },
    textAlign: {
      options: ['left', 'center', 'right'],
    },
    colorPicker: {
      className: undefined,
      component: undefined,
      popupClassName: undefined,
      colors: [
        'rgb(0,0,0)',
        'rgb(255,255,255)',
        'rgb(255,0,0)',
        'rgb(255,153,0)',
        'rgb(255,255,0)',
        'rgb(0,255,0)',
        'rgb(0,255,255)',
        'rgb(0,0,255)',
        'rgb(153,0,255)',
        'rgb(255,0,255)',
      ],
    },
    link: {
      options: ['link', 'unlink'],
    },
    embedded: {
      defaultSize: {
        height: 'auto',
        width: 'auto',
      },
    },
  };

  return (
    <div className="wysiwyg_container">
      <div className="col-md-12 editor h-100">
        <Editor
          editorState={description}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editorClassName"
          onEditorStateChange={onEditorStateChange}
          toolbar={toolbarOptions}
        />
        <textarea
          style={{ display: 'none' }}
          disabled
          ref={(val) => (moduleInfo.description = val)}
          value={draftToHtml(convertToRaw(description.getCurrentContent()))}
        />
      </div>
    </div>
  );
};

export default Wysiwyg;
